import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";

export default function CouponApply({ onClose, onSubmit, dialogDetails }) {
  const [campaignData, setCampaignData] = useState(dialogDetails?.campaignData || []);
  const [couponCode, setCouponCode] = useState(0);
  const [couponManual, setCouponManual] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const showSnackbar = useSnackbar();



  const handleCouponChange = (e) => {
    setCouponManual(e.target.value);
  };

  const applySelectedCoupon = () => {
    onSubmit( couponCode);
  };

    const checkCodeAvailability = () => {
     setCouponCode(0);
     setSelectedId('');
     onSubmit(couponManual);
       
    };

  return (
    <div className="w-full max-w-lg mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <div className="text-base font-semibold">APPLY COUPON</div>
        <button
          className="absolute top-4 right-4 text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      {/* Coupon code input */}
      <div className="flex items-center p-4 border-b">
        <input
          type="text"
          placeholder="Enter Coupon Code"
          value={couponManual}
          onChange={handleCouponChange}
          className="p-2 text-sm border border-gray-300 rounded-l-md w-2/3 focus:outline-none"
        />
        <button
          className="p-2 text-sm bg-green-700 text-white rounded-r-md w-1/3 hover:bg-green-800"
          onClick={() => {checkCodeAvailability()}}
        >
          Check
        </button>
      </div>

      {/* Coupons List */}
      <div className="p-4 space-y-4 max-h-64 overflow-y-auto">
        {campaignData.map((coupon) => (
          <div
            key={coupon.id}
            onClick={() => {
              setSelectedId(coupon.id);
              setCouponCode(coupon.code);
              setCouponManual("")
            }}
            className={`flex items-start gap-2 cursor-pointer p-3 border rounded-lg ${
              selectedId === coupon.id
                ? "border-[#02537F] bg-[#f0f6fa]"
                : "border-gray-200"
            }`}
          >
            {/* Selection check */}
            <div
              className={`mt-1 h-5 w-5 flex items-center justify-center rounded border-2
                ${
                  selectedId === coupon.id
                    ? "bg-[#02537F] border-[#02537F]"
                    : "border-gray-400"
                }`}
            >
              {selectedId === coupon.id && (
                <FaCheck className="text-white text-xs" />
              )}
            </div>

            {/* Coupon info */}
            <div>
              <div className="flex items-center gap-2">
                <span
                  className={`font-bold px-2 py-1 rounded-md text-xs tracking-wide border
                  ${
                    selectedId === coupon.id
                      ? "text-[#02537F] border-[#02537F]"
                      : "border-gray-400 text-gray-400"
                  }`}
                >
                  {coupon.code}
                </span>

                <span className=" text-gray-800 font-semibold">{coupon.name}</span>
              </div>
              <div className="mt-1 text-lg font-bold text-gray-800">
                {coupon.discountText}
              </div>
              <div className="text-sm text-gray-600">{coupon.details}</div>
              <div className="text-xs mt-1 text-gray-400">
                Expires on:{" "}
                <span className="font-medium text-gray-700">
                  {coupon.expires}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-end border-t p-4">
        {/* <div className="text-sm text-gray-500">
          {selectedId
            ? `Maximum savings: ${
                campaignData.find(c => c.id === selectedId)?.maxSavings || "-"
              }`
            : ""}
        </div> */}
        <CustomButton
          onClick={applySelectedCoupon}
          customeClass={`customer-dark-button w-full sm:w-[150px] h-[40px] ${
            !couponCode && !couponManual ? "opacity-60 cursor-not-allowed" : ""
          }`}
          disabled={!couponCode && !couponManual}
        >
          Apply
        </CustomButton>
      </div>
    </div>
  );
}
